import translate from "components/translations/translations.wrapper";

export const LinkToHelpCenter = ({ translate }) => {
    const helpCenterReplacementUrl = window.ENVIRONMENT?.HELP_CENTER_URL;
    return (
        <li className="icon" title={translate("menu.helpBoxReplacement.label")}>
            <a className="button-help text-transparent" target="tab-helpcenter" href={helpCenterReplacementUrl}>
                <span className="vismaicon help-center-new-tab" />
                <span className="notificationBadge badge" />
            </a>
        </li>
    );
};

export default translate(LinkToHelpCenter);